module.exports = __webpack_public_path__ + "img/04c7a6d.jpg";